'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
require('../../../../theme/Shadows.cjs.js');
require('../../../../theme/Typography.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const skeletonBlock = "_skeleton-block_m7n5q_9";
const streakAnimation = "_streak-animation_m7n5q_1";
const styles = {
	skeletonBlock: skeletonBlock,
	streakAnimation: streakAnimation
};

const SkeletonBlock = ({ aspectRatio = void 0, borderRadius = "medium", height = void 0, width = "100%", color = "GrayWarm2" }) => {
  const blockHeight = typeof height === "number" ? `${height}px` : height;
  const blockWidth = typeof width === "number" ? `${width}px` : width;
  return React__default.default.createElement("div", { className: styles.skeletonBlock, "data-border-radius": borderRadius, "data-testid": "SkeletonBlock", "data-zds": true, style: {
    "--skeleton-block-width": blockWidth,
    "--skeleton-block-padding-top": aspectRatio ? `calc(${width} / ${aspectRatio})` : blockHeight || 0,
    "--skeleton-block-background-color": theme_Colors.Colors[color]
  } });
};

exports.SkeletonBlock = SkeletonBlock;
//# sourceMappingURL=SkeletonBlock.cjs.js.map
